import React, { Component } from "react";

export default class Experience extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="experience">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <span className="heading-meta">Experience</span>
                <h2 className="colorlib-heading animate-box">
                  Work Experience
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInRight"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-2">
                        <i className="icon-pen2"></i>
                      </div>
                      <div className="timeline-label">
                      <h2>
                      <a href="#">Software Engineer II at Oracle</a>{" "}
                      <span>February 2022 - Present</span>
                    </h2>
                        <p>
                          Part of the Hybrid Service Manager team that facilitates provisioning of various OCI services. <br />Focusing and investing my time on Cloud Infrastructure, Distributed Systems, Microservices Architecture, Kubernetes, Docker, Jenkins, Service Deployment, SaaS, IaaS, PaaS{" "}
                        </p>
                      </div>
                    </div>
                  </article>
                <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInRight"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2"></i>
                      </div>
                      <div className="timeline-label">
                      <h2>
                      <a href="#">Software Engineer II at Bola.AI</a>{" "}
                      <span>February 2021 - January 2022</span>
                    </h2>
                        <p>
                          • Worked on improving the user experience of an AI-Voice assistant using the JavaScript framework ElectronJS{" "}
                          <br />
                          • Managed and executed the development of an end-to-end NodeJS based touch-less charting feature for over 800 users{" "}
                          <br />
                          • Improved user experience by increasing usage speeds by 60% by modularizing and optimizing code <br />
                          • Developed a REST API for managing user authentication, order management and access privileges using NestJS
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-1">
                        <i className="icon-pen2"></i>
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <a href="#">Software Engineering Intern at BEVI</a>{" "}
                          <span>January 2020 - August 2020</span>
                        </h2>
                        <p>
                          • Developed and deployed a client-side Python
                          application to improve testing of the Bevi machine
                          controls and firmware by enabling interaction with the
                          Bevi Java backend using Remote Method Invocation{" "}
                          <br />• Improved monitoring and debugging of the Bevi
                          Android Application by writing AWS Lambda functions to
                          deobfuscate stack traces and thread dumps in real time{" "}
                          <br />
                          • Designed and developed a REST API for managing the
                          controls of a Bevi machine in the Bevi Java backend
                          application <br />
                          • Streamlined the integration process of multiple
                          applications by configuring them with CircleCI to
                          implement continuous integration <br />• Setup log
                          monitoring and tracking of the Bevi backend on Datadog
                        </p>
                      </div>
                    </div>
                  </article>

                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInRight"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-2">
                        <i className="icon-pen2"></i>
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <a href="#">Software Engineering Intern at KAYAK</a>{" "}
                          <span>June 2019 - August 2019</span>
                        </h2>
                        <p>
                          • Tracked Service Level Objectives of the company by
                          developing a tool integrated with SignalFx using Ruby
                          on Rails <br />
                          • Improved log monitoring system by writing cron jobs
                          that communicate with Kibana using their API <br />•
                          Developed Report Generator for Quality Managers to
                          reduce manual effort in generating quarterly reports{" "}
                          <br />• Worked with Hive and PostgreSQL for carrying
                          out database CRUD operations
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInRight"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2"></i>
                      </div>
                      <div className="timeline-label">
                        <h2>
                          <a href="#">
                            Teaching Assistant for Computer Systems at
                            Northeastern University
                          </a>{" "}
                          <span>January 2019 - December 2019</span>
                        </h2>
                        <p>
                          • Tutored a Computer Systems class of 150 students
                          over 2 semesters for the following topics: <br />
                          Processes, threads, mutexes and memory allocation,
                          linux system calls and file systems
                        </p>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
